<template>
  <QPaginatedSearchDropdown :value="value" :list-getter="getMachineListFromFilter" :filter="filter"
    :min-search-char-limit="0" :externaledit="externaledit" :clearable="clearable" :multiple="multiple" :disableAttach="disableAttach"
    :returnobject="returnobject" :disabled="disabled" :loading="loading" valuekey="Id" textkey="DisplayName"
    :label="label ? label : $t('servicesystem.common_objects.machine.machine')"
    :placeholder="placeholder ? placeholder : $t('servicesystem.common_objects.machine.search_field_label')"
    @input="e => $emit('input', e)" @FocusState="e => $emit('FocusState', e)">
    <!-- extra logic to hide icon when in single mode and value is set -->
    <template v-if="!hideIcon && ((!multiple && !value) || multiple)" v-slot:prepend-outer>
      <v-icon size="20">$machine</v-icon>
    </template>
    <template v-if="!multiple" v-slot:selection="{ item }">
      <MachineLi :machine="item" :disabled="true" :showServiceAgreement="showServiceAgreement"
        style="padding-left: 0px !important;" />
    </template>
  </QPaginatedSearchDropdown>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import QPaginatedSearchDropdown from "@/components/Inputs/QPaginatedSearchDropdown.vue";
import MachineLi from "@/components/ListItems/MachineListItem.vue";
import rules from "@/helpers/Mixins/QInputRuleMixin.js";

export default {
  name: "MachineSelect2",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    label: String,
    placeholder: String,
    value: [Object, String, Number, Array],
    clearable: Boolean,
    disabled: Boolean,
    loading: Boolean,
    externaledit: Boolean,
    filter: Object,
    returnobject: Boolean,
    multiple: Boolean,
    showServiceAgreement: {
      type: Boolean,
      default: true,
    },
    hideIcon: Boolean,
    disableAttach: Boolean,
  },
  components: {
    QPaginatedSearchDropdown,
    MachineLi,
  },
  mixins: [clientAPI, rules],

  data() {
    return {
    };
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang="scss"></style>